<template>
    <div class="ts_search">
        <div v-if="filterItem.type === 'numberRange' || filterItem.type ==='numberRangeArr'">
            <el-input-number v-model="numMin" :min="0" :controls="false" class="number_range_input"></el-input-number>
            -
            <el-input-number v-model="numMax" :min="0" :controls="false" class="number_range_input"></el-input-number>
            <el-button type="primary" class="number_range_btn" @click="submit">确定</el-button>
        </div>
        <div v-if="filterItem.type === 'select'">
            <el-radio-group v-model="selectValue" @input="submit">
                <el-radio v-for="item in filterItem.selectList" :key="item.value" :label="item.value" class="select_item">{{ item.label }}</el-radio>
            </el-radio-group>
        </div>
        <div v-if="filterItem.type === 'multipleSelect'">
            <el-checkbox-group v-model="selectArr">
                <el-checkbox v-for="item in filterItem.selectList" :key="item.value" :label="item.value" class="select_item">{{ item.label }}</el-checkbox>
            </el-checkbox-group>
            <div style="display: flex;">
                <el-button type="primary" class="multiple_select_btn" @click="submit">确定</el-button>
            </div>
        </div>
        <div v-if="filterItem.type === 'dateRangeArr'">
            <el-date-picker
                v-model="selectValue"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
                @change="submit">
            </el-date-picker>
        </div>
    </div>
</template>

<script>
    import TsSearchObj from './TsSearchObj';

    export default {
        props: {
            filterItem: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                numMin: undefined,
                numMax: undefined,
                selectValue: '',
                selectArr: []
            }
        },
        mounted() {
            this.getDefaultFilterItem();
        },
        methods: {
            getDefaultFilterItem() {
                if (this.filterItem.defaultSearchValue !== undefined) {
                    switch (this.filterItem.type) {
                        case 'multipleSelect':
                            this.selectArr = this.filterItem.defaultSearchValue;
                            this.submit();
                            break;
                        case 'numberRange':
                            this.numMin = this.filterItem.defaultSearchValue[0];
                            this.numMax = this.filterItem.defaultSearchValue[1];
                            this.submit();
                            break;
                        case 'numberRangeArr':
                            this.numMin = this.filterItem.defaultSearchValue[0];
                            this.numMax = this.filterItem.defaultSearchValue[1];
                            this.submit();
                            break;
                        default:
                            this.selectValue = this.filterItem.defaultSearchValue;
                            this.submit();
                            break;
                    }
                }
            },
            clear() {
                this.numMin = undefined;
                this.numMax = undefined;
                this.selectArr = [];
                this.selectValue = '';
            },
            submit() {
                switch (this.filterItem.type) {
                    case 'numberRange':
                        if (this.numMin === undefined || this.numMax === undefined) {
                            return;
                        }
                        if (this.numMin > this.numMax) {
                            let n = this.numMin;
                            this.numMin = this.numMax;
                            this.numMax = n;
                        }
                        this.pushTab([this.numMin, this.numMax]);
                        break;
                    case 'numberRangeArr':
                        if (this.numMin === undefined || this.numMax === undefined) {
                            return;
                        }
                        if (this.numMin > this.numMax) {
                            let n = this.numMin;
                            this.numMin = this.numMax;
                            this.numMax = n;
                        }
                        this.pushTab([this.numMin, this.numMax]);
                        break;
                    case 'select':
                        if (!this.selectValue) {
                            return;
                        }
                        this.pushTab(this.selectValue);
                        break;
                    case 'multipleSelect':
                        // if (!this.selectArr.length) {
                        //     return;
                        // }
                        this.pushTab(this.selectArr);
                        break;
                    case 'dateRangeArr':
                        if (!this.selectValue) {
                            return;
                        }
                        this.pushTab(this.selectValue);
                        break;
                    default:
                        break;
                }
            },
            pushTab(value) {
                let { type, param, name, label } = this.filterItem;
                if (type === 'select') {
                    label = this.filterItem.selectList.find(item => item.value === value).label;
                }
                if (type === 'multipleSelect') {
                    let arr = [];
                    value.forEach(item => {
                        arr.push(this.filterItem.selectList.find(i => i.value === item).label);
                    });
                    label = arr.join(',');
                }
                this.$emit('pushTab', new TsSearchObj(param, name, value, type, label).tags);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .number_range_input {
        width: 100px;
    }
    ::v-deep .el-input-number .el-input__inner {
        text-align: left !important;
    }
    .number_range_btn {
        width: 80px;
        margin: 0 0 0 10px;
    }
    .multiple_select_btn {
        width: 80px;
    }
    .select_item {
        display: block;
        padding: 5px 0;
    }
</style>
